import React from "react"
import { Link } from "gatsby"
import StrapiMedia from "../strapi-media"
import { StaticImage } from "gatsby-plugin-image"

const BlogItem = ({ blog, params, lineClamp, isBlogPage }) => {
  const { title, thumbnail, desc, url, categories } = blog.attributes
  const blogCategory = categories?.data.reduce(
    (total, item) => total + item.attributes.value.replace(/\s/g, "") + " ",
    ""
  )
  return (
    <div
      className={`${
        isBlogPage
          ? `blog-item mb-10 lg:mb-[90px] ${blogCategory}`
          : "w-full mx-auto xl:mt-20"
      }
      
      `}
    >
      <Link
        to={`/${params.location}/blog/${url}/`}
        className="underline font-bold"
      >
        {thumbnail && thumbnail.data ? (
          <StrapiMedia
            image={thumbnail}
            isLazyLoad={false}
            className="w-full pointer-events-none"
          />
        ) : (
          <StaticImage
            src="../../static/images/icon/redsoda-logo-light.svg"
            alt="logo"
          />
        )}
      </Link>

      <Link to={`/${params.location}/blog/${url}/`}>
        <p
          className={`font-syne--20 lg:font-syne--22 font-bold mt-8 
          line-clamp-${lineClamp || 3} 
          ${lineClamp === 2 ? "h-[66px]" : "h-[95px]"}`}
        >
          {title}
        </p>
      </Link>
      <p
        className={`font-montserrat--18 mt-4 mb-10 lg:my-10 
          line-clamp-${lineClamp || 3} 
          ${lineClamp === 2 ? "h-[54px]" : "h-[82px]"}`}
      >
        {desc}
      </p>
      <Link
        to={`/${params.location}/blog/${url}/`}
        className="underline font-bold"
        title={`${title}`}
      >
        READ MORE
      </Link>
    </div>
  )
}

export default BlogItem
